<template>
  <pricing-table-row custom-class="calculation">
    <template #description>
      {{ label }}
    </template>
    <template #value>
      <span v-if="amount !== null" class="calculation-specification">
        {{ amount }}
        <span v-html="unit"></span>
        <span class="multiply">
        ⨉
        </span>
        <span>{{ toCurrencyLongEur(unitPrice) }}</span>
        =
      </span>
      {{ toCurrencyEur(totalPrice) }}
    </template>
  </pricing-table-row>
</template>

<script>
import PricingTableRow from 'vue-elements/product-info/PricingTableRow.vue';

export default {
  components: {
    PricingTableRow,
  },
  props: [
      'label',
      'amount',
      'unit',
      'unitPrice',
      'totalPrice'
  ],
}
</script>

<style scoped>
.calculation-specification {
  font-size: 12px;
  margin-right: 8px;
}
.multiply {
  font-size: 8px;
  margin-left: 2px;
  margin-right: 2px;
}
</style>
